export enum B2BTrackingEvents {
  ReportDownload = 'report_download',
  DeactivateMembers = 'deactivate_members',
  ReinviteMembers = 'reinvite_members',
  ReinviteMembersPartial = 'reinvite_members_partial',
  PromoteToManager = 'promote_to_manager',
  RevokeManagerAccess = 'revoke_manager_access',
}

export enum B2BTrackingParameters {
  B2BSource = 'b2b_source',
}

export enum B2BTrackingValues {
  B2BMain = 'b2b_main',
  B2BMemberProfile = 'b2b_member_profile',
}